<template>
    <div class="Products">
        <div class="ProductsBox">
            <div class="title">{{ $t('i18n_423') }}</div>
            <div class="timeTab">
                <div @click="yearChange(item)" v-for="item in yearList" :key="item"
                    :class="year == item ? 'active' : ''" class="timeItem ">{{ item }}</div>
            </div>
            <div v-if="isPc" class="ProductsList">
                <div @click="$refs.pcCarousel.prev()" class="arrowBtn arrowLeft">
                    <img src="@/assets/index/bannerBtn.png" alt="" />
                </div>
                <div @click="$refs.pcCarousel.next()" class="arrowBtn arroRight">
                    <img src="@/assets/index/bannerBtn.png" alt="" />
                </div>
                <el-carousel ref="pcCarousel" :autoplay="false" indicator-position="none" trigger="click" height="350px">
                    <el-carousel-item v-for="(item, index) in showList" :key="index">
                        <div class="carouselItem">
                            <div @click="$openUrl(item2.jump_url,false)" v-for="(item2, index2) in item" :key="index2" class="ProductsItem">
                                <img class="ProductImg" :src="item2.cover" alt="">
                                <div class="title">{{ item2.title }}</div>
                                <img v-if="item2.new == 1" class="newTag" src="@/assets/index/NewIcon.png" alt="" />
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>

            <div v-else class="ProductsPhone">
                <el-carousel :autoplay="false" indicator-position="none" trigger="click"
                    :height="phoneCarouselHeight + 'px'">
                    <el-carousel-item v-for="(item, index) in mobileList" :key="index">
                        <div class="ProductsItem">
                            <img class="ProductImg" :src="item.cover" alt="">
                            <div class="title">{{ item.title }}</div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>

<script>
import indexTitle from "@/components/c/indexTitle.vue"
import { get_product_list } from "@/api/news"
export default {
    components: {
        indexTitle,
    },
    data() {
        return {
            year: null,
            yearList: [],
            dataList: [],
            phoneCarouselHeight: 350,
            isPc: true,
        }
    },
    created() {
        this.getProductData()
        this.phoneCarouselHeight = window.innerWidth * (30 / 38) + 52
        if (window.innerWidth < 1200) {
            this.isPc = false
        }
    },
    computed: {
        showList() {
            let data = this.dataList.find(el => el.year == this.year)
            return data ? this.convertArray(data.list) : []
        },
        mobileList() {
            let data = this.dataList.find(el => el.year == this.year)
            return data ? data.list : []
        }
    },
    mounted() {

    },
    methods: {
        getProductData() {
            get_product_list().then(res => {
                this.yearList = res.data.map(el => {
                    return el.year
                })
                // this.yearList = this.yearList.sort((a, b) => a - b)
                this.yearList.length ? this.year = this.yearList[0] : this.year = null
                this.dataList = res.data
            })
        },
        yearChange(year) {
            this.year = year
        },
        convertArray(arr) {
            const result = [];
            for (let i = 0; i < arr.length; i += 3) {
                result.push(arr.slice(i, i + 3));
            }
            return result;
        }
    }
}
</script>

<style scoped lang="scss">
.Products {
    padding-bottom: 150px;
    background: #fff;

    .ProductsBox {
        width: 1200px;
        margin: auto;

        .title {
            font-weight: 500;
            font-size: 40px;
            color: #000000;
            line-height: 69px;
        }

        .timeTab {
            display: flex;
            justify-content: center;
            border-top: 1px solid #888888;
            border-bottom: 1px solid #888888;
            overflow: hidden;
            margin-top: 50px;

            .timeItem {
                height: 58px;
                text-align: center;
                line-height: 58px;
                width: 150px;
                font-size: 22px;
                color: #000000;
                cursor: pointer;
                position: relative;

                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 0;
                    height: 1px;
                    background: #000000;
                    left: 50%;
                    transition: all 0.3s;
                }
            }

            .active {
                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1px;
                    background: #000000;
                }
            }
        }

        .ProductsList {
            margin-top: 70px;
            position: relative;

            .arrowBtn {
                position: absolute;
                top: 130px;
                cursor: pointer;

                img {
                    width: 36px;
                    height: 36px;
                    transition: all 0.3s;

                    &:hover {
                        width: 40px;
                        height: 40px;
                    }
                }
            }

            .arrowLeft {

                left: -80px;
            }

            .arroRight {
                transform: rotate(180deg);
                right: -80px
            }

            .carouselItem {
                display: flex;
                align-items: center;
                gap: 30px;

                .ProductsItem {
                    width: 380px;
                    position: relative;

                    .ProductImg {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 19 / 15;
                        object-fit: cover;
                        display: block;
                    }

                    .title {
                        text-align: center;
                        font-size: 20px;
                        color: #000000;
                        line-height: 24px;
                        margin-top: 28px;
                        height: 24px;
                        overflow: hidden;
                    }

                    .newTag{
                        width: 40px;
                        height: 20px;
                        position: absolute;
                        top: 21px;
                        right: 31px;
                    }
                }
            }
        }
    }
}

::v-deep .ProductsList {
    .el-carousel__arrow--left {
        display: none !important;
    }

    .el-carousel__arrow--right {
        display: none !important;
    }
}

@media screen and (max-width:1200px) {

    .Products {
        padding-top: 50px;
        padding-bottom: 50px;
        background: #fff;

        .ProductsBox {
            width: 100%;
            margin: auto;

            .title {
                font-weight: 500;
                font-size: 24px;
                color: #000000;
                line-height: 30px;
                padding: 0 30px;
                font-weight: bold;
            }

            .timeTab {
                display: flex;
                justify-content: center;
                border-top: 1px solid #888888;
                border-bottom: 1px solid #888888;
                overflow: auto;
                margin-top: 50px;

                .timeItem {
                    height: 58px;
                    text-align: center;
                    line-height: 58px;
                    width: 150px;
                    font-size: 22px;
                    color: #000000;
                    cursor: pointer;
                    position: relative;

                    &:after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 0;
                        height: 1px;
                        background: #000000;
                        left: 50%;
                        transition: all 0.3s;
                    }
                }

                .active {
                    &:after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        height: 1px;
                        background: #000000;
                    }
                }
            }

            .ProductsPhone {
                margin-top: 70px;

                .ProductsItem {
                    width: 100%;

                    .ProductImg {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 19 / 15;
                        object-fit: cover;
                        display: block;
                    }

                    .title {
                        text-align: center;
                        font-size: 20px;
                        color: #000000;
                        line-height: 24px;
                        margin-top: 28px;
                        height: 24px;
                        overflow: hidden;
                    }
                }
            }

        }
    }
}
</style>